import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { CopyFormProps, useCopyForm } from "../../hooks/useCopyForm";

interface CopyFormButtonProps<T> {
  hooksProps: CopyFormProps<T>;
  children?: React.ReactNode;
  values: T;
}

export function CopyFormButton<T>({
  children,
  values,
  hooksProps,
  ...btnProps
}: CopyFormButtonProps<T> & ButtonProps) {
  const { copyForm } = useCopyForm<T>(hooksProps);

  return (
    <Button
      colorScheme="cherryButton"
      {...btnProps}
      type="button"
      onClick={() => copyForm(values)}
    >
      {children ?? "Copy Form"}
    </Button>
  );
}
